import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { WeekendRouteOverlapModalActions } from "./WeekendRouteOverlapModalActions";
import { WeekendRouteOverlapModalContent } from "./WeekendRouteOverlapModalContent";
import { weekendRouteOverlapWarningSelector } from "../../../reducers/ownApp/selectors";
import { setWeekendRouteOverlapWarning } from "../../../reducers/ownApp";
import {
  resolveCopyOverlap,
  savePlan,
} from "../../../reducers/matrixProfile/thunkActions";

export const WeekendRouteOverlapModal = memo(() => {
  const dispatch = useDispatch();
  const warning = useSelector(weekendRouteOverlapWarningSelector);

  const onCancel = () => {
    if (warning?.isCopy) {
      dispatch(resolveCopyOverlap({ cancelCopy: true }));
      return;
    }
    dispatch(setWeekendRouteOverlapWarning(null));
  };

  const onContinue = () => {
    if (warning?.isCopy) {
      dispatch(resolveCopyOverlap({ cancelCopy: false }));
      return;
    }
    dispatch(setWeekendRouteOverlapWarning(null));
    dispatch(savePlan({ overlapValidation: false }));
  };

  return (
    <Modal
      open={!!warning}
      onClose={onCancel}
      title={"Warning - Overlapping Routes"}
      content={
        warning ? (
          <WeekendRouteOverlapModalContent
            isCopy={warning.isCopy}
            targetDayName={warning.targetDayName}
            conflictingPlans={warning.conflictingPlans}
          />
        ) : null
      }
      actions={
        <WeekendRouteOverlapModalActions
          onCancel={onCancel}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
      minWidth={500}
    />
  );
});
